import React from 'react';
import styles from './ShareChallengeBox.module.css';
import moment from 'moment';

export default class ShareChallengeBox extends React.Component {
  render() {
    const {
      eventName,
      chapterName,
      eventStartTime,
      miles,
      steps,
      hours,
      minutes,
      seconds,
    } = this.props;

    return (
      <div className={styles.container}>
        <h3 className={styles.eventNameTitle}>{eventName?.toUpperCase()}</h3>
        <h5>{chapterName}</h5>
        <h6>{moment(eventStartTime).format('dddd, MMMM DD')}</h6>

        <div className={styles.detailsContainer}>
          <span>
            <h1>
              {parseFloat(miles)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
            </h1>
            <h6>MILES</h6>
          </span>
          <span>
            <h1>
              {parseInt(steps)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
            </h1>
            <h6>STEPS</h6>
          </span>
          <span>
            <h1>
              {hours}:{minutes}:{seconds}
            </h1>
            <h6>DURATION</h6>
          </span>
        </div>
      </div>
    );
  }
}
